import GlobalStyles from '@mui/system/GlobalStyles'
import { getResponsiveSize } from 'theme/styles.utils'
import { important } from 'utils/styles/stylesUtils'

export default function MaterialIcons() {
  return (
    <GlobalStyles
      styles={{
        '.material-icons': {
          fontFamily: 'Material Icons, sans-serif',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: important(getResponsiveSize(20, 'px')),
          lineHeight: 1,
          letterSpacing: 'normal',
          textTransform: 'none',
          display: 'inline-block',
          whiteSpace: 'nowrap',
          wordWrap: 'normal',
          direction: 'ltr',
        },
      }}
    />
  )
}
